module.exports = __webpack_public_path__ + "static/media/logo.6c5f8b24.png";